<template>
  <div class="container1">
    <div class="class0" style="font-size:80px;margin-top:100px;font-family:Arial;letter-spacing:2px">Error<br><br></div>
    <div class="class1">您扫描的二维码尚未保存，将在3个小时内失效<br>
      <div class="class11">若要长期使用，请将美钥码保存。<br>
                            点击继续<a :href='toUrl'>跳转</a></div></div>
    <div class="class2">联系电话：010-82333641<br> 
                        联系邮箱：jvshikeji@163.com<br>
                        <a href="/">美钥码首页</a></div>
</div>
</template>

<script>
export default {
  data () {
    return {
      toUrl: ''
    }
  },
  mounted () {
    this.toUrl = this.$route.query.to
  }
}
</script>

<style scoped>
.container1 {
  color: #fff;
  background-image: url('../../assets/img/cases/back1.jpg');
  background-color: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 100%;
  bottom: 10px;
  overflow: hidden;
  text-align: center;
  line-height: 40px;
}
.class1 {
  margin-top:20px;
  font-size: 28px;
  font-weight: bold;
  line-height: 40px;
}
.class11{
  margin-top:20px;
  font-size: 20px;
  line-height: 30px;
}
.class2 {
  font-size: 16px;
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 10px;
  line-height: 30px;
}
@media (max-width: 400px) {
  .class0 {
    margin-top: 50px;
  }
}
</style>

